import { render, staticRenderFns } from "./OAAppMain.vue?vue&type=template&id=f150eae4&scoped=true&"
import script from "./OAAppMain.vue?vue&type=script&lang=js&"
export * from "./OAAppMain.vue?vue&type=script&lang=js&"
import style0 from "./OAAppMain.vue?vue&type=style&index=0&id=f150eae4&scoped=true&lang=css&"
import style1 from "./OAAppMain.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f150eae4",
  null
  
)

export default component.exports